import { Module, Directive } from 'app/decorators';
import _ from 'lodash';

@Module({
    name: 'app.directives.is.active'
})
@Directive('is-active', function($location) {
    "ngInject";
    return {
        restrict: "A",
        link: function (scope, element, attrs) {
            scope.$watch(() => $location.hash(), function(newHash) {
                if (newHash === attrs.isActive) {
                    element.addClass('active')
                } else {
                    element.removeClass('active')
                }
            })
        }
    }
})
@Directive('default', function($location) {
    "ngInject";
    return {
        restrict: "A",
        link: function (scope, element, attrs) {
            scope.$watch(() => $location.hash(), function(newHash) {
                if (_.isUndefined(newHash) || !newHash) {
                    element.addClass('active');
                }
            })
        }
    }
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/is.active.js